var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPagament(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "300.000000pt",
    height: "300.000000pt",
    viewBox: "0 0 300.000000 300.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,300.000000) scale(0.100000,-0.100000)",
    fill: "#6E6259",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410 2401 c-69 -21 -121 -65 -156 -131 -18 -33 -19 -72 -19 -770 0 -734 0 -735 22 -775 25 -47 64 -85 113 -111 34 -18 81 -19 1130 -19 1049 0 1096 1 1130 19 49 26 88 64 113 111 22 40 22 41 22 775 0 734 0 735 -22 775 -25 47 -64 85 -113 111 -33 18 -82 19 -1115 21 -594 1 -1091 -2 -1105 -6z m2189 -162 l31 -31 0 -124 0 -124 -1130 0 -1130 0 0 124 0 124 31 31 31 31 1068 0 1068 0 31 -31z m31 -933 l0 -514 -31 -31 -31 -31 -1068 0 -1068 0 -31 31 -31 31 0 514 0 514 1130 0 1130 0 0 -514z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555 1125 c-14 -13 -25 -33 -25 -45 0 -11 11 -32 25 -45 23 -24 30 -25 150 -25 120 0 127 1 150 25 14 13 25 34 25 45 0 12 -11 32 -25 45 -23 24 -30 25 -150 25 -120 0 -127 -1 -150 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992 1138 c-43 -21 -42 -96 3 -116 15 -7 75 -12 144 -12 139 0 165 11 163 71 -2 59 -25 69 -166 68 -66 0 -131 -5 -144 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409 1132 c-15 -13 -22 -30 -22 -52 0 -59 26 -70 164 -70 69 0 129 5 144 12 28 13 40 45 31 81 -9 37 -46 47 -175 47 -101 0 -122 -3 -142 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1835 1125 c-14 -13 -25 -33 -25 -45 0 -11 11 -32 25 -45 23 -24 30 -25 150 -25 120 0 127 1 150 25 14 13 25 34 25 45 0 12 -11 32 -25 45 -23 24 -30 25 -150 25 -120 0 -127 -1 -150 -25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagament);
export default __webpack_public_path__ + "static/media/pagament.4b0da77c.svg";
export { ForwardRef as ReactComponent };